import React, { FC, useContext } from "react";
import { GridLegacy as Grid } from "@mui/material";
import { IPreferences } from "../../logic/api";
import EditableField, {
    EditableFieldTypes,
} from "../../components/editable/EditableField/EditableField";
import EditableGroup, {
    EditableGroupType,
} from "../../components/editable/EditableGroup/EditableGroup";
import NotchedCard from "../../components/cards/NotchedCard/NotchedCard";
import { SessionContext } from "../../utility/useSession";
import styles from "./styles";
import { useTranslation } from "react-i18next";

interface IBrandSettingsProps {
    onSave: (data: Partial<IPreferences>) => Promise<boolean>;
}

export const BrandSettings: FC<IBrandSettingsProps> = ({ onSave }) => {

    const { t } = useTranslation();
    const session = useContext(SessionContext);

    if (!session.current.site) {
        return null;
    }

    return (
        <Grid item xs={12}>
            <NotchedCard
                label={t("menuItems.brand")}
                style={styles.card}
                containerProps={{ "data-testid": "brand-settings-card" }}
            >
                <EditableGroup<IPreferences>
                    id="brandSettings"
                    editType={EditableGroupType.switchableEditing}
                    data={session.current.site.preferences}
                    onDataChanged={(data) => onSave({
                        brand_enabled: data.brand_enabled,
                    })}
                    testId="brand-settings"
                >
                    <Grid container>
                        <Grid item sm={2} xs={6}>
                            <EditableField<IPreferences, boolean>
                                useFullWidthWhenEditing={false}
                                inputType={EditableFieldTypes.switch}
                                label={t("reports.enabled")}
                                onProvide={(data) =>
                                    Boolean(data.brand_enabled)
                                }
                                onChange={(data, value) =>
                                    data.brand_enabled = Boolean(value)
                                }
                                testId="settings-brand-enabled-switch"
                            />
                        </Grid>
                    </Grid>
                </EditableGroup>
            </NotchedCard>
        </Grid>
    );
};
